import set from 'transmute/set';
export const setHasChannelSwitchedToEmail = set('hasChannelSwitchedToEmail');